<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <Breadcrumbs headline="Sổ liên lạc" :link="[{ text: 'Sổ liên lạc', href: '/head-contact-book' }]" />
    </div>

    <!-- Filter data -->
    <v-card outlined class="mx-4 mb-6 pa-6">
      <v-row>
        <v-col cols="12" md="10">
          <v-form ref="form" @submit.prevent="search">
            <v-row>
              <v-col cols="12" md="4">
                <DateIOSPicker
                  label="Ngày"
                  :date.sync="time"
                  outlined
                  :rules="[$rules.date, $rules.dateFromNow]"
                  dense
                />
              </v-col>
            </v-row>
          </v-form>
        </v-col>

        <v-col cols="12" md="2" class="d-flex justify-end">
          <v-btn outlined class="search-button" @click="search">Tìm kiếm</v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- table -->
    <v-card outlined class="mx-4">
      <v-data-table
        loading-text="Đang Tải"
        :headers="headers"
        :items="slots"
        :loading="loading"
        :footer-props="{
          'items-per-page-text': 'Hiển thị mỗi trang',
          'items-per-page-all-text': 'Tất cả',
          'items-per-page-options': slots.length > 100 ? [10, 20, 30] : [10, 30, -1]
        }"
      >
        <template v-slot:[`item.title`]="{ item }">
          <router-link style="text-decoration: none" :to="`/head-contact-book/${item.id}/${time}`">
            {{ item.title }}
          </router-link>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip v-if="item.status === 'draft'" small label color="orange" dark
            ><span>
              Chưa gửi
            </span>
          </v-chip>
          <v-chip v-else small label color="#46BE8A" dark
            ><span>
              Đã gửi
            </span>
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <span style="cursor: pointer" @click="() => goToDetail(item)">
            <v-icon color="primary">mdi-pencil</v-icon>
          </span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import { get } from 'lodash'
export default {
  components: {
    Breadcrumbs,
    DateIOSPicker
  },
  data() {
    return {
      headers: [
        {
          text: 'Lớp',
          value: 'title',
          align: 'left',
          sortable: false
        },
        {
          text: 'Trạng thái',
          value: 'status',
          align: 'left',
          sortable: false
        },
        {
          text: 'Thao tác',
          value: 'actions',
          align: 'left',
          sortable: false
        }
      ],
      time: moment().toISOString(),
      loading: false,
      slots: [],
      moment
    }
  },
  async mounted() {
    this.loading = true
    await this.setTableData()
    this.loading = false
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    isToday() {
      return moment(this.time)
        .startOf('day')
        .isSame(moment().startOf('day'))
    }
  },
  methods: {
    ...mapActions('HeadContactBooks', ['fetchData', 'fetchOwnClass']),
    async search() {
      if (!this.$refs.form.validate()) return

      this.loading = true
      await this.setTableData()
      this.loading = false
    },
    async setTableData() {
      const result = []
      const existedData = await this.fetchData({
        date: moment(this.time)
          .startOf('day')
          .toISOString()
      })

      const ownedClasses = await this.fetchOwnClass({ headTeachers: this.profile.id, _sort: 'title:asc' })

      if (Array.isArray(ownedClasses) && ownedClasses.length) {
        ownedClasses.forEach(ownedClass => {
          result.push({
            id: ownedClass.id,
            title: ownedClass.title,
            status: get(this.getExistedStatus(existedData, ownedClass.id), 'status', 'draft')
          })
        })
      }

      this.slots = [...result]
    },
    getExistedStatus(data = [], findId = '') {
      return data.find(x => x.class.id === findId)
    },
    goToDetail(item) {
      this.$router.push(`/head-contact-book/${item.id}/${this.time}`)
    }
  }
}
</script>
